import React, { ForwardedRef, memo } from 'react';
import cx from 'classnames';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Button } from 'spindl-shared-components';

import styles from './CellCalendarModal.module.scss';
import usePresenter from './CellCalendarModal.presenter';
import getProps from './CellCalendarModal.props';
import { CellCalendarModalCombinedProps } from './types';

// MANUAL OVERRIDE - converted to forwardRef Component
const CellCalendarModal = React.forwardRef<DatePicker, CellCalendarModalCombinedProps>((props, ref) => {
  const {
    className,
    classes,
    cancelButton,
    doneButton,
    clearButton,
    onInputChanged,
    date,
    timeInputLabel,
    dateFormat,
    showTime,
    timeOnly,
    popperProps,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.cellCalendarModal;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const CustomInput = memo(React.forwardRef(({ value }: any, inputRef: ForwardedRef<HTMLInputElement>) => {
    return (
      <input
        readOnly
        ref={inputRef}
        tabIndex={-1}
        value={value}
      />
    );
  }));

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.modalContainer, classes?.modalContainer)}> 
        <div className={cx(styles.modal, classes?.modal)}>
          <DatePicker
            selected={date}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onChange={onInputChanged!}
            timeInputLabel={timeInputLabel}
            dateFormat={dateFormat}
            showTimeInput={showTime || timeOnly}
            showTimeSelectOnly={timeOnly}
            customInput={<CustomInput />}
            shouldCloseOnSelect={false}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ref={ref}
            {...internalProps.popperProps}
            {...popperProps}
          >
            <div className={cx(styles.buttons, classes?.buttons)}>
              <Button 
                {...internalProps.cancelButton} 
                {...clearButton}
              />
              <Button 
                {...internalProps.cancelButton} 
                {...cancelButton}
              />
              <Button 
                {...internalProps.doneButton} 
                {...doneButton}
              />
            </div>
          </DatePicker>
        </div>
      </div>
    </div>
  );
}); // MANUAL OVERRIDE

export default CellCalendarModal;
